import {
  FETCH_NOTIFICATIONS_SUCCEED,
  ADD_NOTIFICATIONS_SUCCEED,
  UPDATE_NOTIFICATIONS_SUCCEED,
  DELETE_NOTIFICATIONS_SUCCEED,
} from '../actions/notification/action_types';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
        notification: action.params.data,
      };
    case ADD_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    case UPDATE_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    case DELETE_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
